/*
 * @Description:
 * @Author: kadenwang@tencent.com
 * @Date: 2020-05-19 15:45:35
 * @LastEditors: kadenwang@tencent.com
 * @LastEditTime: 2020-05-19 15:45:36
 */

import Market from './Market';

const Ipc = {

  /**
  * send message to another browser window
  */
  SendMessage: (browserId: number, message: string): Promise<{}> => Market.__asyncCallApi('Ipc.SendMessage', { browserId, message }),

  /**
   * send message to all browser windows
   */
  BroadCastMessage: (message: string): Promise<{}> => Market.__asyncCallApi('Ipc.BroadCastMessage', { message }),
};

export default Ipc;
